import { Button, TextField } from "@mui/material"
import { useState } from "react"

export default function ClaveSiiuam(props) {
    const { folio, solicitud, setSolicitud } = props

    const [claveSiiuam, setClaveSiiuam] = useState({ id: null, clave: '', idSolicitud: solicitud.id })
    const [capturandoClave, setCapturandoClave] = useState(false)
    const [helper, setHelper] = useState('')
    const [errorClave, setErrorClave] = useState(false)
    const handleSubmitClave = async (e) => {
        e.preventDefault()
        //console.log(capturandoClave)
        if (capturandoClave) {
            const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/guardarClave`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                },
                body: JSON.stringify({ claveSiiuam })
            })
            const data = await res.json()

            if (res.status === 200) {
                setSolicitud(solicitud)
                setErrorClave(false)
                setHelper('')
                setClaveSiiuam({ id: null, clave: '', idSolicitud: solicitud.id })
                setCapturandoClave(false)
                // solicitud.comentarioSolicituds.unshift(comentarioGuardado)
            }
            else {
                setErrorClave(true)
                setCapturandoClave(true)
                setHelper(data.message ? data.message.startsWith('llave duplicada') || data.message.startsWith('Validation error') ? 'Esa clave ya existe' : data.message : '')
            }


            return

        }
        else {
            setCapturandoClave(true)
        }
    }
    return (

        <form onSubmit={handleSubmitClave}>
            <TextField helperText={helper} value={claveSiiuam.clave} error={errorClave} style={{ display: capturandoClave ? 'block' : 'none', marginTop: 20 }} name="clave" label="Clave SIIUAM" focused required={capturandoClave} multiline onChange={(event) => {
                setClaveSiiuam({ ...claveSiiuam, [event.target.name]: event.target.value.trim() })
            }} onKeyDown={(event)=>{if (event.key === 'Escape') {
                setCapturandoClave(false)
            }}}/>
            <Button key={folio} type="submit"
                size='small'
                variant='contained'
                style={{ marginTop: 20, backgroundColor: "darkgreen", color: 'white', width: '80%' }}

            >
                {capturandoClave ? 'Guardar' : 'Capturar clave SIIUAM'}
            </Button>
        </form>)
}